/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/assets/js/theme.js":
/*!********************************!*\
  !*** ./src/assets/js/theme.js ***!
  \********************************/
/***/ (() => {

    function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
    var _document$querySelect;
    function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
    function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
    function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
    function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
    function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
    function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
    function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
    function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
    // SoundCloud-style bars
    
    // document.getElementById('playPause').onclick = playPause;
    //
    // function playPause() {
    //     const element = document.getElementById("playPause");
    //     const waveform_with_product = document.querySelector('#waveform_with_product')
    //     const waveform_without_product = document.querySelector('#waveform_without_product')
    //     element.classList.toggle("playing");
    //
    //     const checkboxChecker = document.getElementById("toggle");
    //
    //     waveform_with_product.playPause();
    //     waveform_with_product.setVolume(1);
    //
    //     waveform_without_product.playPause();
    //     waveform_without_product.setVolume(1);
    //
    //     if (checkboxChecker.checked) {
    //         //Play with product
    //         console.log('checked');
    //
    //         waveform_without_product.setVolume(0);
    //         waveform_without_product.setProgressColor('transparent');
    //
    //         waveform_with_product.setProgressColor('#0E2F4F');
    //     } else {
    //         console.log('NOT checked');
    //
    //         waveform_with_product.setVolume(0);
    //         waveform_with_product.setProgressColor('transparent');
    //
    //         waveform_without_product.setProgressColor('#0E2F4F');
    //     }
    // }
    //
    // const toggle = document.querySelector("#toggle");
    // const unchecked = document.getElementById("unchecked");
    // const checked = document.getElementById("checked");
    //
    // toggle.addEventListener('change', function() {
    //     if (this.checked) {
    //         //console.log('changed to checked');
    //         waveform_without_product.setVolume(0);
    //         waveform_with_product.setVolume(1);
    //
    //         waveform_without_product.setProgressColor('transparent');
    //
    //         waveform_with_product.setProgressColor('#0E2F4F');
    //
    //
    //         unchecked.classList.remove("active");
    //         checked.classList.add("active");
    //
    //     } else {
    //         //console.log('unchecked');
    //         waveform_with_product.setVolume(0);
    //         waveform_without_product.setVolume(1);
    //
    //         waveform_with_product.setProgressColor('transparent');
    //
    //         waveform_without_product.setProgressColor('#0E2F4F');
    //
    //         unchecked.classList.add("active");
    //         checked.classList.remove("active");
    //
    //     }
    // });
    // Form validation ---------------------------------
    
    var countryData;
    var index = 0;
    var phoneInput = document.querySelectorAll('.phone');
    phoneInput.forEach(function (input, i) {
      index = i;
      var phoneInput = window.intlTelInput(input, {
        preferredCountries: ['ua', 'pl'],
        initialCountry: 'ua',
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.21/js/utils.js'
      });
      countryData = phoneInput.getSelectedCountryData();
      input.value = "+".concat(countryData.dialCode);
      input.addEventListener('countrychange', function () {
        countryData = phoneInput.getSelectedCountryData();
        input.value = "+".concat(countryData.dialCode);
      });
    });
    [].forEach.call(document.querySelectorAll('.phone'), function (input) {
      var keyCode;
      function mask(event) {
        event.keyCode && (keyCode = event.keyCode);
        var pos = this.selectionStart;
        var matrix = "+".concat(countryData.dialCode, "-___-___-___"),
          i = 0,
          def = matrix.replace(/\D/g, ''),
          val = this.value.replace(/\D/g, ''),
          new_value = matrix.replace(/[_\d]/g, function (a) {
            return i < val.length ? val.charAt(i++) || def.charAt(i) : a;
          });
        i = new_value.indexOf('_');
        var num = countryData.dialCode.length + 1;
        if (i != -1) {
          i < num && (i = 1);
          new_value = new_value.slice(0, i);
        }
        var reg = matrix.substr(0, this.value.length).replace(/_+/g, function (a) {
          return '\\d{1,' + a.length + '}';
        }).replace(/[+]/g, '\\$&');
        reg = new RegExp('^' + reg + '$');
        if (!reg.test(this.value) || this.value.length < num || keyCode > 47 && keyCode < 58) this.value = new_value;
        if (event.type == 'blur' && this.value.length < num) this.value = '';
      }
      input.addEventListener('input', mask, false);
      input.addEventListener('focus', mask, false);
      input.addEventListener('blur', mask, false);
      input.addEventListener('keydown', mask, false);
      input.addEventListener('keydown', function (e) {
        input.setSelectionRange(input.value.length, input.value.length);
      });
    });
    function validateForm() {
      function validateUserName(input) {
        var regex = /^[a-zA-Zа-яА-ЯіІїЇєЄ']{1,}( [a-zA-Zа-яА-ЯіІїЇєЄ']{1,}){0,2}$/;
        if (regex.test(input.value.trim())) {
          input.classList.remove('invalid');
          return true;
        } else {
          input.classList.add('invalid');
          return false;
        }
      }
      function validateEmail(input) {
        var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (regex.test(input.value.trim())) {
          input.classList.remove('invalid');
          return true;
        } else {
          input.classList.add('invalid');
          return false;
        }
      }
      function validatePhone(input) {
        var regex = new RegExp("^\\+?".concat(countryData.dialCode, "-\\d{3}-\\d{3}-\\d{3}$"));
        if (regex.test(input.value)) {
          input.classList.remove('invalid');
          return true;
        } else {
          input.classList.add('invalid');
          return false;
        }
      }
      function validateFile(input) {
        return !!input.files.length;
      }
      var forms = document.querySelectorAll('form');
      forms.forEach(function (form) {
        var inputs = form.querySelectorAll('.username, .last-name, .email, .phone, #upload-button');
        var submitBtn = form.querySelector('[type="submit"]');
        var debounceTimer;
        var debounce = function debounce(callback) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(callback, 100);
        };
        var validateInput = function validateInput(input) {
          if (input.classList.contains('username') || input.classList.contains('last-name')) {
            return validateUserName(input);
          } else if (input.classList.contains('email')) {
            return validateEmail(input);
          } else if (input.classList.contains('phone')) {
            return validatePhone(input);
          } else if (input.id === 'upload-button') {
            if (input.closest('.active')) {
              return validateFile(input);
            }
          }
          return true;
        };
        var disableButton = function disableButton() {
          var allInputsValid = Array.from(inputs).every(validateInput);
          submitBtn.disabled = !allInputsValid;
        };
        inputs.forEach(function (input) {
          if (input.id === 'upload-button') {
            input.addEventListener('change', function () {
              debounce(function () {
                disableButton();
              });
            });
          } else {
            input.addEventListener('input', function (event) {
              debounce(function () {
                validateInput(event.target);
                disableButton();
              });
            });
          }
        });
      });
    }
    validateForm();
    var openModalBtns = document.querySelectorAll('.open-modal');
    var modalWindows = document.querySelectorAll('.modal');
    function openModal(modal) {
      if (!modal) return;
      closeModalAnimation();
      modal.style.display = 'flex';
      document.body.classList.add('lock');
      setTimeout(function () {
        modal.classList.add('active');
      }, 10);
    }
    function closeModal(event) {
      var modal = document.querySelector('.modal.active');
      // setTimeout(() => {
      //     document.querySelectorAll('video').forEach(video => video.pause());
      // }, 500)
      if (event.target.classList.contains('js-close-btn') || event.target.classList.contains('modal') && modal.classList.contains('active')) {
        closeModalAnimation();
      }
    }
    function closeModalAnimation() {
      var modal = document.querySelector('.modal.active');
      if (!modal) return;
      modal.classList.remove('active');
      document.body.classList.remove('lock');
      setTimeout(function () {
        modal.style.display = 'none';
      }, 350);
    }
    openModalBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var targetModal = btn.getAttribute('data-target');
        var modalWindow = document.querySelector("[data-modal=\"".concat(targetModal, "\"]"));
        openModal(modalWindow, btn);
        if (btn.getAttribute('data-src')) {
          var videoSrc = btn.getAttribute('data-src');
          var posterSrc = btn.getAttribute('data-poster');
          var modalVideoPlayerSrc = document.querySelector('.modal[data-modal="video"] video');
          var modalVideoPlayer = document.querySelector('.modal[data-modal="video"] video');
          modalVideoPlayer.setAttribute('poster', posterSrc);
          if (videoSrc) {
            modalVideoPlayer.src = videoSrc;
            modalVideoPlayer.style.display = 'block';
            // modalVideoPlayer.play();
          } else {
            document.querySelector('.not-found').classList.add('active');
            modalVideoPlayer.style.display = 'none';
          }
        }
      });
    });
    modalWindows.forEach(function (modal) {
      modal.addEventListener('click', function (e) {
        e.stopPropagation();
        closeModal(e);
      });
    });
    document.addEventListener('click', function (e) {
      closeModal(e);
    });
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('blurred-overlay') || e.target.classList.contains('search-modal__container')) {
        document.querySelectorAll('.blurred-overlay').forEach(function (item) {
          return item.classList.remove('active');
        });
      }
    });
    (_document$querySelect = document.querySelector('.search-modal input')) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('keypress', function (e) {
      if (e.key === "Enter") {
        document.querySelectorAll('.blurred-overlay').forEach(function (item) {
          return item.classList.remove('active');
        });
      }
    });
    function removeClass(elements, className) {
      elements.forEach(function (element) {
        element.classList.remove(className);
      });
    }
    function playVideo(e) {
      var IDLE_TIME = 2000;
      var BUTTON_SHOW_DELAY = 2000;
      var button = e.currentTarget;
      var buttonName = button.getAttribute('data-video');
      var video = document.querySelector("video[data-name=\"".concat(buttonName, "\"]"));
      var isPlaying = video.classList.contains('playing');
      var timeout;
      function hideElementOnIdle(element, idleTime) {
        function hideElement() {
          element.classList.add('playing');
        }
        function resetTimeout() {
          clearTimeout(timeout);
          element.classList.remove('playing');
          timeout = setTimeout(hideElement, idleTime);
        }
        document.addEventListener('mousemove', resetTimeout);
        document.addEventListener('keydown', resetTimeout);
        resetTimeout();
      }
      hideElementOnIdle(button, IDLE_TIME);
      function setPause() {
        clearTimeout(timeout); // Clear the timeout that hides the element
    
        if (video && button) {
          video.pause();
          video.removeAttribute('controls');
          video.classList.remove('playing');
          button.classList.remove('playing');
        }
      }
      if (!isPlaying) {
        video.play();
        video.setAttribute('controls', 'true');
        video.classList.add('playing');
        setTimeout(function () {
          return button.classList.add('playing');
        }, BUTTON_SHOW_DELAY);
      } else {
        setPause();
      }
      video.addEventListener("click", function () {
        return setPause();
      });
      video.addEventListener("ended", function () {
        return setPause();
      });
    }
    var playButtons = document.querySelectorAll('button.play-btn');
    playButtons.forEach(function (btn) {
      return btn.addEventListener('click', function (e) {
        return playVideo(e);
      });
    });
    var autoplayedVideos = document.querySelectorAll('video[autoplay]');
    if (autoplayedVideos.length) {
      autoplayedVideos.forEach(function (video) {
        video.addEventListener('loadeddata', function (e) {
          video.play();
          console.log('loaded');
        });
      });
    }
    window.addEventListener('DOMContentLoaded', function () {
      // header ------------------------------------------------
      var menuTriggers = document.querySelectorAll('.open-menu-btn');
      var header = document.querySelector('header');
      var currentMenuIndex = 0;
      var submenuLayers = document.querySelectorAll('[data-menu]');
      menuTriggers.forEach(function (menuTrigger) {
        menuTrigger.addEventListener('click', function () {
          if (menuTrigger.classList.contains('hamburger')) {
            header.classList.toggle('active');
            // document.body.classList.remove('lock');
            // document.documentElement.classList.remove('lock');
            currentMenuIndex = 0;
            submenuLayers.forEach(function (item) {
              return item.classList.remove('active');
            });
          } else {
            currentMenuIndex++;
            var submenu = menuTrigger.querySelector('.sub-menu');
            submenuLayers[currentMenuIndex - 1].classList.add('active');
            submenuLayers[currentMenuIndex - 1].innerHTML = submenu.innerHTML;
            // document.body.classList.add('lock');
            // document.documentElement.classList.add('lock');
    
            var backButton = document.querySelectorAll('.back-to-menu');
            backButton.forEach(function (backBtn) {
              backBtn.addEventListener('click', function () {
                currentMenuIndex--;
                submenuLayers[currentMenuIndex].classList.remove('active');
              });
            });
          }
        });
      });
      function themeHeaderOnScroll(my_header) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var scrollPosition = function scrollPosition() {
          return window.pageYOffset || document.documentElement.scrollTop;
        };
        function changeTheme() {
          if (scrollPosition() > 50) {
            my_header.closest('sticky-header').classList.add('scrolled');
          } else if (scrollPosition() < 100) {
            my_header.closest('sticky-header').classList.remove('scrolled');
          }
        }
        function scrollListener(e) {
          changeTheme(e);
        }
        window.addEventListener("scroll", scrollListener);
      }
      if (!document.body.querySelector('.overlaid')) {
        header.closest('sticky-header').classList.add('scrolled');
      } else {
        themeHeaderOnScroll(header, 50);
      }
      function removeClasses(elements, classes) {
        elements.forEach(function (element) {
          classes.forEach(function (className) {
            element.classList.remove(className);
          });
        });
      }
      document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
        });
      });
    
      // // smooth scroll links ---------------------------------
      // $(document).ready(function () {
      //     $("a").on('click', function (event) {
      //         if (this.hash !== "") {
      //             var hash = this.hash;
      //             header.classList.remove('active');
      //             document.body.classList.remove('lock');
      //             document.documentElement.classList.remove('lock');
      //             $('html, body').animate({
      //                 scrollTop: $(hash).offset().top - 100
      //             }, 700, function () {
    
      //             });
      //             return false;
      //         }
      //     });
      // });
    
      if (window.innerWidth > 992) {
        var dropdownTriggers = document.querySelectorAll('.dropdown-trigger');
        var timeoutId;
        dropdownTriggers.forEach(function (trigger, i) {
          trigger.addEventListener('mouseenter', function (e) {
            removeClasses(dropdownTriggers, ['active']);
            trigger.classList.add('active');
            clearTimeout(timeoutId);
          });
          trigger.addEventListener('mouseleave', function () {
            // Set a timeout to remove the 'active' class after 1 second
            timeoutId = setTimeout(function () {
              removeClasses(dropdownTriggers, ['active']);
            }, 200);
          });
        });
        document.addEventListener('click', function (event) {
          var isDropdownTrigger = event.target && event.target.closest('.dropdown-trigger');
          var isSubmenu = event.target && event.target.closest('.submenu');
          if (!isSubmenu && !isDropdownTrigger) {
            removeClasses(dropdownTriggers, ['active']);
          }
          clearTimeout(timeoutId);
        });
      }
      function showImagesOnHover(containersSelector, imagesSelector, triggersSelector) {
        var submenus = document.querySelectorAll(containersSelector);
        submenus.forEach(function (menu) {
          var images = menu.querySelectorAll(imagesSelector);
          var links = menu.querySelectorAll(triggersSelector);
          links.forEach(function (card, index) {
            card.addEventListener('mouseover', function () {
              images.forEach(function (image) {
                image.style.display = 'none';
              });
              images[index].style.display = 'block';
            });
    
            // card.addEventListener('mouseout', () => {
            //     images.forEach(image => {
            //         image.style.display = 'none';
            //     });
            //     images[0].style.display = 'block';
            // });
          });
        });
      }
    
      showImagesOnHover('.nav-links__submenu', '.submenu-img img', 'ul li');
    });
    if (window.innerWidth > 992) {
      var buttons = document.querySelectorAll(".magnet");
      buttons.forEach(function (button) {
        var distance = parseInt(button.getAttribute('data-distance'));
        button.addEventListener("mousemove", function (e) {
          var _button$getBoundingCl = button.getBoundingClientRect(),
            left = _button$getBoundingCl.left,
            top = _button$getBoundingCl.top,
            width = _button$getBoundingCl.width,
            height = _button$getBoundingCl.height;
          var centerX = left + width / 2;
          var centerY = top + height / 2;
          var deltaX = e.clientX - centerX;
          var deltaY = e.clientY - centerY;
          var percentX = deltaX / (width / 2);
          var percentY = deltaY / (height / 2);
          var translateX = percentX * distance;
          var translateY = percentY * distance;
          button.style.transform = "translate(".concat(translateX, "px, ").concat(translateY, "px)");
        });
        button.addEventListener("mouseleave", function () {
          button.style.transform = "translate(0px, 0px)";
        });
      });
    }
    window.addEventListener("DOMContentLoaded", function () {
      var mainSliders = document.querySelectorAll(".main-slider");
      if (mainSliders.length) {
        mainSliders.forEach(function (slider) {
          var prev = slider.querySelector(".slider-prev");
          var next = slider.querySelector(".slider-next");
          var slidesPerView = slider.getAttribute("data-slides");
          new Swiper(slider, {
            spaceBetween: 32,
            speed: 600,
            grabCursor: true,
            keyboard: {
              enabled: true
            },
            navigation: {
              prevEl: prev,
              nextEl: next
            },
            breakpoints: {
              992: {
                slidesPerView: slidesPerView
              },
              768: {
                slidesPerView: 2
              },
              479: {
                slidesPerView: 2
              },
              0: {
                slidesPerView: 1
              }
            }
          });
        });
      }
      var mobileSliders = document.querySelectorAll(".mobile-slider");
      if (mobileSliders.length) {
        mobileSliders.forEach(function (slider) {
          var prev = slider.querySelector(".slider-prev");
          var next = slider.querySelector(".slider-next");
          new Swiper(slider, {
            spaceBetween: 32,
            speed: 600,
            grabCursor: true,
            keyboard: {
              enabled: true
            },
            // Navigation arrows
            navigation: {
              prevEl: prev,
              nextEl: next
            },
            breakpoints: {
              768: {
                slidesPerView: 2
              },
              479: {
                slidesPerView: 2
              },
              0: {
                slidesPerView: 1
              }
            }
          });
        });
      }
      var samplesSlider = document.querySelectorAll(".samples-slider");
      if (samplesSlider.length) {
        samplesSlider.forEach(function (slider) {
          var slidesPerView = slider.getAttribute("data-slides");
          new Swiper(slider, {
            spaceBetween: 16,
            speed: 500,
            grabCursor: true,
            slidesPerView: 4.5,
            keyboard: {
              enabled: true
            },
            navigation: {
              prevEl: document.querySelector('.samples-slider-wrapper .prev-btn'),
              nextEl: document.querySelector(".samples-slider-wrapper .next-btn")
            },
            breakpoints: {
              992: {
                slidesPerView: 6.5
              },
              768: {
                slidesPerView: 5.5
              },
              479: {
                slidesPerView: 4.5
              },
              0: {
                slidesPerView: 4.5
              }
            }
          });
        });
      }
      function makeProductSliders() {
        var sliders = document.querySelectorAll(".product-info__slider");
        sliders.forEach(function (sliderElement) {
          var productSlider = new Swiper(sliderElement, {
            spaceBetween: 50,
            slidesPerView: 1
          });
          var productThumbs = new Swiper(sliderElement.nextElementSibling, {
            spaceBetween: 6,
            breakpoints: {
              992: {
                slidesPerView: 9
              },
              768: {
                slidesPerView: 6
              },
              0: {
                spaceBetween: 8,
                slidesPerView: 6
              }
            }
          });
    
          // productSlider.controller.control = productThumbs;
          // productThumbs.controller.control = productSlider;
    
          productThumbs.on("click", function () {
            var clickedSlideIndex = productThumbs.clickedIndex;
            productSlider.slideTo(clickedSlideIndex);
            productThumbs.slides.forEach(function (slideEl) {
              slideEl.classList.remove("swiper-slide-active");
            });
            productThumbs.slides[clickedSlideIndex].classList.add("swiper-slide-active");
          });
        });
      }
      makeProductSliders();
      var variantsSlider = document.querySelectorAll(".product-variants__slider");
      if (variantsSlider.length) {
        variantsSlider.forEach(function (slider) {
          var slidesPerView = slider.getAttribute("data-slides");
          new Swiper(slider, {
            spaceBetween: 11,
            speed: 500,
            grabCursor: true,
            slidesPerView: 5,
            keyboard: {
              enabled: true
            },
            breakpoints: {
              992: {
                // slidesPerView,
                slidesPerView: 5
              },
              768: {
                slidesPerView: 5
              }
            }
          });
        });
      }
    });
    var uploadButton = document.getElementById("upload-button");
    if (uploadButton) {
      var uploadedFileNames = [];
      var successMessage = document.getElementById("success-message");
      var fileHandler = function fileHandler(file, name, type) {
        if (!type.includes("pdf") && !type.includes("doc")) {
          // File Type Error
          error.innerText = "Будь ласка, завантажте файл у форматі PDF, DOCX або DOC";
          return false;
        }
        error.innerText = "";
        if (uploadedFileNames.includes(name)) {
          // File already uploaded
          error.innerText = "Такий файл вже завантажено";
          return false;
        }
        uploadedFileNames.push(name);
        successMessage.innerText = "\u0424\u0430\u0439\u043B '".concat(name, "' \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E.");
      };
    
      // Upload Button
      uploadButton.addEventListener("change", function (e) {
        successMessage.innerText = '';
        Array.from(uploadButton.files).forEach(function (file) {
          fileHandler(file, file.name, file.type);
        });
        console.dir(e.target);
      });
    
      // Drag and drop events
      var container = document.querySelector(".dropzone");
      container.addEventListener("dragenter", function (e) {
        e.preventDefault();
        e.stopPropagation();
        container.classList.add("active");
      });
      container.addEventListener("dragleave", function (e) {
        e.preventDefault();
        e.stopPropagation();
        container.classList.remove("active");
      });
      container.addEventListener("dragover", function (e) {
        e.preventDefault();
        e.stopPropagation();
        container.classList.add("active");
      });
      container.addEventListener("drop", function (e) {
        e.preventDefault();
        e.stopPropagation();
        container.classList.remove("active");
        var draggedData = e.dataTransfer;
        var files = draggedData.files;
        Array.from(files).forEach(function (file) {
          fileHandler(file, file.name, file.type);
        });
      });
      window.onload = function () {
        error.innerText = "";
      };
    }
    window.addEventListener("DOMContentLoaded", function () {
      var filterCheckboxes = document.querySelectorAll('.filters-list input[type="checkbox"]');
      var discardFiltersBtn = document.querySelectorAll('.js-discard-filters-btn');
      var applyFiltersBtn = document.querySelector('.js-apply-filters-btn');
      var filtersInputs = document.querySelectorAll('.filters-list input[type="text"]');
      function checkFilters() {
        if (filterCheckboxes.length || filtersInputs.length) {
          var checkedFilters = _toConsumableArray(filterCheckboxes).some(function (input) {
            return input.checked;
          });
          var filledInputs = _toConsumableArray(filtersInputs).some(function (input) {
            return input.value.length;
          });
          discardFiltersBtn.forEach(function (btn) {
            return btn.disabled = !(checkedFilters || filledInputs);
          });
          applyFiltersBtn.disabled = !(checkedFilters || filledInputs);
        }
      }
      checkFilters();
      filterCheckboxes.forEach(function (input) {
        return input.addEventListener('change', checkFilters);
      });
      filtersInputs.forEach(function (input) {
        return input.addEventListener('input', checkFilters);
      });
      discardFiltersBtn.forEach(function (btn) {
        btn.addEventListener('click', function () {
          filterCheckboxes.forEach(function (checkbox) {
            return checkbox.checked = false;
          });
          filtersInputs.forEach(function (input) {
            return input.value = '';
          });
          checkFilters();
        });
      });
    });
    
    // faq -----------------------------------------------
    function expandContent(trigger, content, btn, collapsedHeight) {
      var isExpanded = false;
      if (trigger.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + "px";
        btn.classList.add('expanded-btn');
        isExpanded = true;
      }
      trigger.addEventListener('click', function (e) {
        if (!isExpanded) {
          content.style.maxHeight = content.scrollHeight + "px";
          btn.classList.add('expanded-btn');
          isExpanded = true;
        } else {
          content.style.maxHeight = collapsedHeight + 'px';
          btn.classList.remove('expanded-btn');
          isExpanded = false;
        }
      });
    }
    document.addEventListener('DOMContentLoaded', function () {
      var accordionButton = document.querySelectorAll('.list-content-accordion__trigger');
      var accordionItemContent = document.querySelectorAll('.body-accordion');
      var accordionExpandBtn = document.querySelectorAll('.expand-btn');
      if (accordionButton.length) {
        accordionButton.forEach(function (btn, index) {
          expandContent(btn, accordionItemContent[index], accordionExpandBtn[index], 0);
        });
      }
    });
    function makeActive(items) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "tabs";
      items.forEach(function (item, index) {
        item.addEventListener("click", function (e) {
          removeClass(items, "active");
          if (type === "tabs") {
            toggleTabs(item);
            setActiveImage(index);
          } else if (type === "images") {
            setActiveTab(index);
          }
          item.classList.add("active");
        });
      });
    }
    function setActiveImage(index) {
      var images = document.querySelectorAll(".row-variants__images img");
      removeClass(images, "active");
      if (images[index]) {
        images[index].classList.add("active");
      }
    }
    function setActiveTab(index) {
      var tabsContainers = document.querySelectorAll(".js-tabs");
      tabsContainers.forEach(function (container) {
        var tabs = _toConsumableArray(container.querySelectorAll(".js-tabs-item"));
        removeClass(tabs, "active");
        if (tabs[index]) {
          tabs[index].classList.add("active");
          toggleTabs(tabs[index]);
        }
      });
    }
    function toggleTabs(trigger) {
      var tabName = trigger.getAttribute("data-name");
      var tabTarget = trigger.getAttribute("data-tab");
      var allContents = document.querySelectorAll("[data-content][data-name=".concat(tabName, "]"));
      var content = document.querySelectorAll("[data-content=".concat(tabTarget, "][data-name=").concat(tabName, "]"));
      removeClass(allContents, "active");
      content.forEach(function (item) {
        return item === null || item === void 0 ? void 0 : item.classList.add("active");
      });
    }
    var tabsContainers = document.querySelectorAll(".js-tabs");
    tabsContainers.forEach(function (container) {
      var tabs = container.querySelectorAll(".js-tabs-item");
      makeActive(tabs);
    });
    var images = document.querySelectorAll(".row-variants__images img");
    makeActive(images, "images");
    var hasOneActive = document.querySelectorAll(".has-one-active");
    hasOneActive.forEach(function (container) {
      var items = container.querySelectorAll(".has-one-active-item");
      items.forEach(function (item) {
        item.addEventListener("click", function () {
          removeClass(items, "active");
          item.classList.add("active");
        });
      });
    });
    document.addEventListener("DOMContentLoaded", function () {
      var header = document.querySelector(".steps-header");
      var sections = document.querySelectorAll(".step-section");
      if (sections.length && header) {
        var handleTabClick = function handleTabClick(event) {
          var targetSectionId = event.currentTarget.getAttribute("data-target");
          var targetSection = document.getElementById(targetSectionId);
          window.scrollTo({
            top: targetSection.offsetTop - 240,
            behavior: "smooth"
          });
        };
        var scrollToElement = function scrollToElement(element) {
          if (element) {
            var scrollContainer = element.parentElement;
            var scrollLeft = element.offsetLeft;
            scrollContainer.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        };
        var updateActiveTabAndHeaderStatus = function updateActiveTabAndHeaderStatus() {
          var firstSectionTop = sections[0].getBoundingClientRect().top;
          var lastSectionBottom = sections[sections.length - 1].getBoundingClientRect().bottom;
          if (firstSectionTop > window.innerHeight / 2 || lastSectionBottom < window.innerHeight / 2) {
            header.classList.remove("active");
          } else {
            header.classList.add("active");
          }
          var newActiveElement = null;
          sections.forEach(function (section) {
            var rect = section.getBoundingClientRect();
            if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
              newActiveElement = section;
              var targetId = section.id;
              steps.forEach(function (step) {
                if (step.getAttribute("data-target") === targetId) {
                  step.classList.add("active");
                } else {
                  step.classList.remove("active");
                }
              });
            }
          });
          if (newActiveElement !== currentActiveElement) {
            currentActiveElement = newActiveElement;
            scrollToElement(headerStepsContainer.querySelector('.active'));
          }
        };
        sections.forEach(function (section, index) {
          var stepNameElement = section.querySelector('.step-name');
          if (stepNameElement.textContent.includes('Step')) {
            var stepElement = document.createElement('div');
            var sectionName = stepNameElement.textContent.trim().replace("Step ".concat(index + 1, ": "), '').replace('.', '');
            stepElement.classList.add('steps-header__item');
            stepElement.setAttribute('data-target', "step-".concat(index + 1));
            stepElement.innerHTML = "\n                    <span class=\"text-md\">Step ".concat(index + 1, "</span>\n                    <span class=\"text-md regular gray\">").concat(sectionName, "</span>\n                ");
            header.appendChild(stepElement);
          }
        });
        var steps = document.querySelectorAll(".steps-header__item");
        var headerStepsContainer = document.querySelector('.header__steps');
        steps.forEach(function (tab) {
          tab.addEventListener("click", handleTabClick);
        });
        var currentActiveElement = null;
        window.addEventListener("scroll", updateActiveTabAndHeaderStatus);
        window.addEventListener("resize", updateActiveTabAndHeaderStatus);
        updateActiveTabAndHeaderStatus();
      }
    });
    window.addEventListener("DOMContentLoaded", function () {
    
      // On scroll animation ----------------------------------------------------
      //
      // const animItems = document.querySelectorAll('.anim_item');
      //
      // if(animItems.length > 0) {
      //     document.addEventListener('scroll', animOnScroll);
      //     document.querySelectorAll('.first_screen_anim').forEach(item => {
      //         setTimeout(() => item.classList.add('_active_anim'), 100);
      //     })
      // }
      //
      // function animOnScroll() {
      //     animItems.forEach(animItem => {
      //         const animItemHeight = animItem.offsetHeight;
      //         const animItemOffset = offset(animItem).top;
      //         const animStart = 1;
      //
      //         let animItemPoint = window.innerHeight - animItemHeight / animStart;
      //         if(animItemHeight > window.innerHeight) {
      //             animItemPoint = window.innerHeight - window.innerHeight / animStart;
      //         }
      //
      //         if((pageYOffset > animItemOffset - animItemPoint) &&
      //             pageYOffset < (animItemOffset + animItemHeight)) {
      //             let time = setTimeout(() => {
      //                 animItem.classList.add('_active_anim');
      //             }, 100);
      //         }
      //     });
      // }
      //
      // function offset(el) {
      //     const rect = el.getBoundingClientRect(),
      //         scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      //         scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      //     return {
      //         top: rect.top + scrollTop,
      //         left: rect.left + scrollLeft
      //     };
      // }
    });
    document.addEventListener("DOMContentLoaded", function () {
      if (document.querySelector('.product-main-wrapper')) {
        document.querySelectorAll('.product-main-wrapper').forEach(function (productContainer) {
          var selectColorBtn = productContainer.querySelector('.select-color-btn');
          if (selectColorBtn) {
            productContainer.querySelectorAll('.product-color-item').forEach(function (item) {
              item.addEventListener('click', function (e) {
                var name = item.getAttribute('data-title');
                selectColorBtn.setAttribute('data-color', name);
                if (item.getAttribute('data-size')) {
                  var size = item.getAttribute('data-size');
                  selectColorBtn.setAttribute('data-size', size);
                }
              });
            });
            selectColorBtn.addEventListener('click', function () {
              var color = this.getAttribute('data-color');
              productContainer.querySelector("[data-name=\"".concat(color, "\"]")).click();
            });
          }
        });
      }
    });
    window.calculatePrice = function (price, item) {
      console.log(price, item);
    };
    function updateProductPrices() {
      if (!document.querySelector('.product__info-wrapper')) {
        return;
      }
      document.querySelectorAll('.product__info-wrapper').forEach(function (productContainer) {
        var quantityInput = productContainer.querySelector('.quantity__input');
        var priceItem = productContainer.querySelector('.price-item');
        if (priceItem) {
          var priceText = priceItem.textContent.trim();
          var price = parseFloat(priceText.replace(/[^\d\.]/g, ''));
          var currencySymbol = priceText.replace(/[\d\.]/g, '').trim().split(' ')[0];
          var currencyCode = priceText.split(' ').pop();
          var newPrice = price * parseInt(quantityInput.value);
          var priceHolder = productContainer.querySelector('.price-holder');
          if (priceHolder) {
            priceHolder.textContent = "".concat(currencySymbol).concat(newPrice.toFixed(2));
          }
        }
      });
    }
    
    // Run the function every 500 milliseconds
    setInterval(updateProductPrices, 500);
    // function addToCart(_x) {
    //   return _addToCart.apply(this, arguments);
    // }
    // function _addToCart() {
    //   _addToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(variations) {
    //     var baseUrl, _iterator, _step, variation, formData, response, data;
    //     return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    //       while (1) switch (_context2.prev = _context2.next) {
    //         case 0:
    //           baseUrl = '/cart/add.js';
    //           _iterator = _createForOfIteratorHelper(variations);
    //           _context2.prev = 2;
    //           _iterator.s();
    //         case 4:
    //           if ((_step = _iterator.n()).done) {
    //             _context2.next = 25;
    //             break;
    //           }
    //           variation = _step.value;
    //           formData = new FormData();
    //           formData.append('id', variation.variation_id);
    //           formData.append('quantity', variation.quantity);
    //           _context2.prev = 9;
    //           _context2.next = 12;
    //           return fetch(baseUrl, {
    //             method: 'POST',
    //             body: formData
    //           });
    //         case 12:
    //           response = _context2.sent;
    //           _context2.next = 15;
    //           return response.json();
    //         case 15:
    //           data = _context2.sent;
    //           console.log('Item added:', data);
    //           // Handle successful addition here
    //           _context2.next = 23;
    //           break;
    //         case 19:
    //           _context2.prev = 19;
    //           _context2.t0 = _context2["catch"](9);
    //           console.error('Error adding item:', _context2.t0);
    //           // Handle any errors here
    //           return _context2.abrupt("break", 25);
    //         case 23:
    //           _context2.next = 4;
    //           break;
    //         case 25:
    //           _context2.next = 30;
    //           break;
    //         case 27:
    //           _context2.prev = 27;
    //           _context2.t1 = _context2["catch"](2);
    //           _iterator.e(_context2.t1);
    //         case 30:
    //           _context2.prev = 30;
    //           _iterator.f();
    //           return _context2.finish(30);
    //         case 33:
    //           setTimeout(function () {
    //             fetch(window.location.href).then(function (response) {
    //               return response.text();
    //             }).then(function (html) {
    //               var parser = new DOMParser();
    //               var doc = parser.parseFromString(html, 'text/html');
    //               document.querySelector('cart-drawer').innerHTML = doc.querySelector('cart-drawer').innerHTML;
    //               document.querySelector('#cart-icon-bubble').innerHTML = doc.querySelector('#cart-icon-bubble').innerHTML;
    //               document.querySelector('.header__icon--cart').click();
    //               document.querySelector('cart-drawer').classList.remove('is-empty');
    //             })["catch"](function (err) {
    //               console.warn('Something went wrong.', err);
    //             });
    //           }, 500);
    //         case 34:
    //         case "end":
    //           return _context2.stop();
    //       }
    //     }, _callee2, null, [[2, 27, 30, 33], [9, 19]]);
    //   }));
    //   return _addToCart.apply(this, arguments);
    // }
    // window.addSingleProductToCart = /*#__PURE__*/function () {
    //   var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(variationId) {
    //     var quantity,
    //       baseUrl,
    //       formData,
    //       response,
    //       data,
    //       _args = arguments;
    //     return _regeneratorRuntime().wrap(function _callee$(_context) {
    //       while (1) switch (_context.prev = _context.next) {
    //         case 0:
    //           quantity = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
    //           baseUrl = '/cart/add.js';
    //           formData = new FormData();
    //           formData.append('id', variationId);
    //           formData.append('quantity', quantity);
    //           _context.prev = 5;
    //           _context.next = 8;
    //           return fetch(baseUrl, {
    //             method: 'POST',
    //             body: formData
    //           });
    //         case 8:
    //           response = _context.sent;
    //           _context.next = 11;
    //           return response.json();
    //         case 11:
    //           data = _context.sent;
    //           console.log('Item added:', data);
    //           // Optionally update the cart UI here
    
    //           // Refresh and open cart drawer
    //           setTimeout(function () {
    //             fetch(window.location.href).then(function (response) {
    //               return response.text();
    //             }).then(function (html) {
    //               var parser = new DOMParser();
    //               var doc = parser.parseFromString(html, 'text/html');
    //               document.querySelector('cart-drawer').innerHTML = doc.querySelector('cart-drawer').innerHTML;
    //               document.querySelector('#cart-icon-bubble').innerHTML = doc.querySelector('#cart-icon-bubble').innerHTML;
    //               document.querySelector('.header__icon--cart').click();
    //               document.querySelector('cart-drawer').classList.remove('is-empty');
    //             })["catch"](function (err) {
    //               console.warn('Something went wrong.', err);
    //             });
    //           }, 500);
    //           _context.next = 19;
    //           break;
    //         case 16:
    //           _context.prev = 16;
    //           _context.t0 = _context["catch"](5);
    //           console.error('Error adding item:', _context.t0);
    //           // Handle any errors here
    //         case 19:
    //         case "end":
    //           return _context.stop();
    //       }
    //     }, _callee, null, [[5, 16]]);
    //   }));
    //   return function (_x2) {
    //     return _ref.apply(this, arguments);
    //   };
    // }();
    // document.addEventListener('DOMContentLoaded', function () {
    //   var addButton = document.getElementById('add_selected_to_cart');
    //   if (addButton) {
    //     addButton.addEventListener('click', function () {
    //       var checkboxes = document.querySelectorAll('input[name="samples"]:checked');
    //       var variationsToAdd = [];
    //       checkboxes.forEach(function (checkbox) {
    //         variationsToAdd.push({
    //           variation_id: checkbox.getAttribute('data-variation-id'),
    //           quantity: 1 // You can adjust this or fetch from another attribute if needed
    //         });
    //       });
    
    //       if (variationsToAdd.length) {
    //         addToCart(variationsToAdd);
    //       } else {
    //         alert('Please select at least one product variation.');
    //       }
    //     });
    //   }
    //   // samples ---------------------------
    
    //   var samplesWrappers = document.querySelectorAll('.select-samples-wrapper');
    //   samplesWrappers.forEach(function (wrapper) {
    //     var sampleCheckboxes = wrapper.querySelectorAll('.samples-checkbox input');
    //     var samplesImagesWrapper = wrapper.querySelector('.samples-images-wrapper');
    //     var chosenSamplesWrapper = wrapper.querySelector('.samples-images-wrapper .chosen-products');
    //     var totalElement = wrapper.querySelector('.samples-total');
    //     var samplesCountElement = wrapper.querySelector('.chosen-samples-count');
    //     // if(sampleCheckboxes.length) {
    //     sampleCheckboxes.forEach(function (checkbox) {
    //       checkbox.addEventListener('change', function (e) {
    //         var checkedSamples = _toConsumableArray(sampleCheckboxes).filter(function (item) {
    //           return item.checked;
    //         });
    //         if (checkedSamples.length) {
    //           samplesImagesWrapper.classList.add('has-samples');
    //           document.querySelector('.chosen-samples-wrapper').classList.add('has-samples');
    //         } else {
    //           samplesImagesWrapper.classList.remove('has-samples');
    //           document.querySelector('.chosen-samples-wrapper').classList.remove('has-samples');
    //         }
    //         var allSamplesItem = document.querySelector(".sample-color-item[data-variation-id=\"".concat(checkbox.getAttribute('data-variation-id'), "\"]"));
    //         var mobileSamplesItem = document.querySelector(".product-variants-mobile-item[data-variation-id=\"".concat(checkbox.getAttribute('data-variation-id'), "\"]"));
    //         allSamplesItem.classList.toggle('active');
    //         mobileSamplesItem.classList.toggle('active');
    //         if (checkbox.checked) {
    //           var thumbnail = checkbox.getAttribute('data-thumb-src');
    //           var thumbWrapper1 = createThumbnail(thumbnail);
    //           var allSamplesWrapper = document.querySelector('.chosen-samples-wrapper .chosen-products');
    //           allSamplesWrapper.append(thumbWrapper1);
    //           var thumbWrapper2 = createThumbnail(thumbnail);
    //           chosenSamplesWrapper.append(thumbWrapper2);
    //         } else {
    //           removeThumbnail(checkbox.id);
    //         }
    //         if (samplesCountElement) {
    //           samplesCountElement.textContent = checkedSamples.length;
    //         }
    //         var samplesChosenColorsText = wrapper.querySelector('.samples-chosen-colors-text');
    //         if (checkedSamples.length) {
    //           samplesChosenColorsText.textContent = checkedSamples.map(function (item) {
    //             return item.getAttribute('data-title');
    //           }).join(', ');
    //         } else {
    //           samplesChosenColorsText.textContent = 'Choose colors';
    //         }
    //         var total = checkedSamples.reduce(function (sum, item) {
    //           return sum + +item.getAttribute('data-price');
    //         }, 0);
    //         totalElement.textContent = total;
    //       });
    //       function createThumbnail(thumbnailSrc) {
    //         var thumbWrapper = document.createElement('div');
    //         thumbWrapper.classList.add('thumb-wrapper');
    //         var thumbEl = new Image();
    //         thumbEl.id = '#' + checkbox.id;
    //         thumbEl.src = thumbnailSrc;
    //         thumbWrapper.append(thumbEl);
    //         return thumbWrapper;
    //       }
    //       function removeThumbnail(checkboxId) {
    //         var chosenSamples = document.querySelectorAll('.thumb-wrapper img');
    
    //         // Use attribute selector to find elements with id equal to checkboxId
    //         var samplesToRemove = document.querySelectorAll(".thumb-wrapper img[id=\"#".concat(checkboxId, "\"]"));
    //         samplesToRemove.forEach(function (sample) {
    //           if (sample) {
    //             sample.parentElement.remove();
    //           }
    //         });
    //       }
    //     });
    //     // }
    //   });
    // });
    
    document.addEventListener('DOMContentLoaded', function () {
      function setupFooterToggle() {
        var headings = document.querySelectorAll('.footer-block__heading');
        headings.forEach(function (heading) {
          heading.onclick = function () {
            // Checking if the screen width is up to 992px
            if (window.innerWidth <= 992) {
              var nextUl = heading.nextElementSibling;
              heading.classList.toggle('active');
              // Ensure the next element is a 'ul' before toggling the class
              if (nextUl && nextUl.tagName === 'UL') {
                nextUl.classList.toggle('footer-block__active');
              }
            }
          };
        });
      }
    
      // Call the function initially
      setupFooterToggle();
    
      // Re-apply the function on window resize
      window.onresize = function () {
        setupFooterToggle();
      };
    });
    
    /***/ }),
    
    /***/ "./src/assets/scss/product-media-gallery-new.scss":
    /*!********************************************************!*\
      !*** ./src/assets/scss/product-media-gallery-new.scss ***!
      \********************************************************/
    /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
    
    "use strict";
    __webpack_require__.r(__webpack_exports__);
    // extracted by mini-css-extract-plugin
    
    
    /***/ }),
    
    /***/ "./src/assets/scss/theme.scss":
    /*!************************************!*\
      !*** ./src/assets/scss/theme.scss ***!
      \************************************/
    /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
    
    "use strict";
    __webpack_require__.r(__webpack_exports__);
    // extracted by mini-css-extract-plugin
    
    
    /***/ }),
    
    /***/ "./src/assets/scss/style.scss":
    /*!************************************!*\
      !*** ./src/assets/scss/style.scss ***!
      \************************************/
    /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
    
    "use strict";
    __webpack_require__.r(__webpack_exports__);
    // extracted by mini-css-extract-plugin
    
    
    /***/ }),
    
    /***/ "./src/assets/scss/dynamic-text-image-section.scss":
    /*!*********************************************************!*\
      !*** ./src/assets/scss/dynamic-text-image-section.scss ***!
      \*********************************************************/
    /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
    
    "use strict";
    __webpack_require__.r(__webpack_exports__);
    // extracted by mini-css-extract-plugin
    
    
    /***/ })
    
    /******/ 	});
    /************************************************************************/
    /******/ 	// The module cache
    /******/ 	var __webpack_module_cache__ = {};
    /******/ 	
    /******/ 	// The require function
    /******/ 	function __webpack_require__(moduleId) {
    /******/ 		// Check if module is in cache
    /******/ 		var cachedModule = __webpack_module_cache__[moduleId];
    /******/ 		if (cachedModule !== undefined) {
    /******/ 			return cachedModule.exports;
    /******/ 		}
    /******/ 		// Create a new module (and put it into the cache)
    /******/ 		var module = __webpack_module_cache__[moduleId] = {
    /******/ 			// no module.id needed
    /******/ 			// no module.loaded needed
    /******/ 			exports: {}
    /******/ 		};
    /******/ 	
    /******/ 		// Execute the module function
    /******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/ 	
    /******/ 		// Return the exports of the module
    /******/ 		return module.exports;
    /******/ 	}
    /******/ 	
    /******/ 	// expose the modules object (__webpack_modules__)
    /******/ 	__webpack_require__.m = __webpack_modules__;
    /******/ 	
    /************************************************************************/
    /******/ 	/* webpack/runtime/chunk loaded */
    /******/ 	(() => {
    /******/ 		var deferred = [];
    /******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
    /******/ 			if(chunkIds) {
    /******/ 				priority = priority || 0;
    /******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
    /******/ 				deferred[i] = [chunkIds, fn, priority];
    /******/ 				return;
    /******/ 			}
    /******/ 			var notFulfilled = Infinity;
    /******/ 			for (var i = 0; i < deferred.length; i++) {
    /******/ 				var [chunkIds, fn, priority] = deferred[i];
    /******/ 				var fulfilled = true;
    /******/ 				for (var j = 0; j < chunkIds.length; j++) {
    /******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
    /******/ 						chunkIds.splice(j--, 1);
    /******/ 					} else {
    /******/ 						fulfilled = false;
    /******/ 						if(priority < notFulfilled) notFulfilled = priority;
    /******/ 					}
    /******/ 				}
    /******/ 				if(fulfilled) {
    /******/ 					deferred.splice(i--, 1)
    /******/ 					var r = fn();
    /******/ 					if (r !== undefined) result = r;
    /******/ 				}
    /******/ 			}
    /******/ 			return result;
    /******/ 		};
    /******/ 	})();
    /******/ 	
    /******/ 	/* webpack/runtime/hasOwnProperty shorthand */
    /******/ 	(() => {
    /******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
    /******/ 	})();
    /******/ 	
    /******/ 	/* webpack/runtime/make namespace object */
    /******/ 	(() => {
    /******/ 		// define __esModule on exports
    /******/ 		__webpack_require__.r = (exports) => {
    /******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    /******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
    /******/ 			}
    /******/ 			Object.defineProperty(exports, '__esModule', { value: true });
    /******/ 		};
    /******/ 	})();
    /******/ 	
    /******/ 	/* webpack/runtime/jsonp chunk loading */
    /******/ 	(() => {
    /******/ 		// no baseURI
    /******/ 		
    /******/ 		// object to store loaded and loading chunks
    /******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
    /******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
    /******/ 		var installedChunks = {
    /******/ 			"/assets/theme": 0,
    /******/ 			"assets/dynamic-text-image-section": 0,
    /******/ 			"assets/style": 0,
    /******/ 			"assets/theme": 0,
    /******/ 			"assets/product-media-gallery-new": 0
    /******/ 		};
    /******/ 		
    /******/ 		// no chunk on demand loading
    /******/ 		
    /******/ 		// no prefetching
    /******/ 		
    /******/ 		// no preloaded
    /******/ 		
    /******/ 		// no HMR
    /******/ 		
    /******/ 		// no HMR manifest
    /******/ 		
    /******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
    /******/ 		
    /******/ 		// install a JSONP callback for chunk loading
    /******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
    /******/ 			var [chunkIds, moreModules, runtime] = data;
    /******/ 			// add "moreModules" to the modules object,
    /******/ 			// then flag all "chunkIds" as loaded and fire callback
    /******/ 			var moduleId, chunkId, i = 0;
    /******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
    /******/ 				for(moduleId in moreModules) {
    /******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
    /******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
    /******/ 					}
    /******/ 				}
    /******/ 				if(runtime) var result = runtime(__webpack_require__);
    /******/ 			}
    /******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
    /******/ 			for(;i < chunkIds.length; i++) {
    /******/ 				chunkId = chunkIds[i];
    /******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
    /******/ 					installedChunks[chunkId][0]();
    /******/ 				}
    /******/ 				installedChunks[chunkId] = 0;
    /******/ 			}
    /******/ 			return __webpack_require__.O(result);
    /******/ 		}
    /******/ 		
    /******/ 		var chunkLoadingGlobal = self["webpackChunkdawn_tailwind_starter"] = self["webpackChunkdawn_tailwind_starter"] || [];
    /******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
    /******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
    /******/ 	})();
    /******/ 	
    /************************************************************************/
    /******/ 	
    /******/ 	// startup
    /******/ 	// Load entry module and return exports
    /******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
    /******/ 	__webpack_require__.O(undefined, ["assets/dynamic-text-image-section","assets/style","assets/theme","assets/product-media-gallery-new"], () => (__webpack_require__("./src/assets/js/theme.js")))
    /******/ 	__webpack_require__.O(undefined, ["assets/dynamic-text-image-section","assets/style","assets/theme","assets/product-media-gallery-new"], () => (__webpack_require__("./src/assets/scss/product-media-gallery-new.scss")))
    /******/ 	__webpack_require__.O(undefined, ["assets/dynamic-text-image-section","assets/style","assets/theme","assets/product-media-gallery-new"], () => (__webpack_require__("./src/assets/scss/theme.scss")))
    /******/ 	__webpack_require__.O(undefined, ["assets/dynamic-text-image-section","assets/style","assets/theme","assets/product-media-gallery-new"], () => (__webpack_require__("./src/assets/scss/style.scss")))
    /******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/dynamic-text-image-section","assets/style","assets/theme","assets/product-media-gallery-new"], () => (__webpack_require__("./src/assets/scss/dynamic-text-image-section.scss")))
    /******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
    /******/ 	
    /******/ })()
    ;